import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { authAxios } from "../../config/config";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import ReactSelect from 'react-select';
import { correctContactValue } from "../../Helper/helper";

const AddDoctors = ({ handleCancel, handleAdd, allmodel, handleUpdate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [formData, setFormData] = useState({
        name: { en: "", ar: "" },
        department: "",
        address: { en: "", ar: "" },
        about: { en: "", ar: "" },
        image: "",
        email: "",
        contactNumberOne: "",
        contactNumberTwo: "",
        insideJordan: true,
        // healthCenter: "",
        discountMessage: { en: "", ar: "" },
        website: "",
        facebook: "",
        instagram: "",
        twitter: "",
        youtube: "",
        linkedin: ""
    });
    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        if (file.size > 10 * 1024 * 1024) {
            toast.error("File size should be less than 10MB.");
            return;
        }


        const formData = new FormData();
        formData.append("file", file);
        await authAxios()
            .post("/admin/upload/single", formData)
            .then((response) => {
                const resData = response.data;
                console.log("handleProfileChange", resData)
                toast.success(resData.message);
                setFormData((prev) => ({
                    ...prev,
                    image: resData.data.url
                }))
            })
            .catch((error) => {

                toast.error(error.response.data.message);
            });
    };

    const [allHealthCenter, setAllHealthCenter] = useState([]);
    const [allDepartments, setAllDepartments] = useState([]);
    console.log(allDepartments);

    const currentLanguage = i18next.language;

    const handleInputChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: typeof value === "object" ? value : { ...prev[field], [lang]: value },
        }));
    };

    const fetchHealthCenter = async () => {
        try {
            const response = await authAxios().get(`/admin/health-centers`);
            setAllHealthCenter(response?.data?.data?.healthCenters);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    const fetchDepartments = async () => {
        try {
            const response = await authAxios().get(`/admin/departments`);
            setAllDepartments(response?.data?.data?.departments);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { ...formData };

        console.log("SdSdasda", payload)

        if (allmodel?.data?._id) {
            handleUpdate(payload);
        } else {
            handleAdd(payload);
        }
    };

    useEffect(() => {
        fetchHealthCenter();
        fetchDepartments();
        if (allmodel?.data?._id) {
            setFormData({
                ...formData,
                ...allmodel.data,
                department: allmodel.data.department?._id || "",

            });
        }
    }, []);

    console.log("eqrqweqw", allmodel.data)
    const departmentOptions = allDepartments.map((department) => ({
        value: department._id,
        label: department?.name[currentLanguage],
    }));
    return (
        <div className="fixed inset-0 z-10">
            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6">
                                {allmodel?.data?._id ? "Update Doctor" : "Add Doctor"}
                            </h2>
                            <div className="flex items-center gap-4">
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2"></label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">English </label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">Arabic</label>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {[
                                    { field: "name", label: "Name" },
                                    { field: "about", label: "About" },
                                ].map(({ field, label }) => (
                                    <div key={field} className="flex  gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">{label}</label>

                                        {field === "about" ? (
                                            <div className="flex flex-col w-full">
                                                <textarea
                                                    required
                                                    placeholder={`${label} (EN)`}
                                                    value={formData[field]?.en || ""}
                                                    onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                                    className="flex-1 mb-4 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                    rows={5}
                                                />
                                                <textarea
                                                    required
                                                    placeholder={`${label} (AR)`}
                                                    value={formData[field]?.ar || ""}
                                                    onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                    rows={5}
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                <input
                                                    type="text"
                                                    placeholder={`${label} (EN)`}
                                                    required
                                                    value={formData[field]?.en || ""}
                                                    onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder={`${label} (AR)`}
                                                    value={formData[field]?.ar || ""}
                                                    onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                                                    required
                                                    className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                />
                                            </>
                                        )}
                                    </div>
                                ))}
                                {[
                                    { field: "address", label: "Address" },
                                    { field: "discountMessage", label: "Discount Message" },

                                ].map(({ field, label }) => (
                                    <div key={field} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">{label}</label>
                                        <input
                                            type="text"
                                            placeholder={`${label} (EN)`}

                                            value={formData[field]?.en || ""}
                                            onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${label} (AR)`}
                                            value={formData[field]?.ar || ""}
                                            onChange={(e) => handleInputChange(field, "ar", e.target.value)}

                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}


                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                                    <input
                                        type="text"
                                        placeholder="Contact Number One"

                                        value={formData.contactNumberOne}
                                        onChange={(e) => setFormData({ ...formData, contactNumberOne:  correctContactValue(e.target.value) })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Contact Number Two"
                                        value={formData.contactNumberTwo}
                                        onChange={(e) => setFormData({ ...formData, contactNumberTwo: correctContactValue(e.target.value) })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Email</label>
                                    <input
                                        type="text"
                                        placeholder="Enter email"

                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />

                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Department</label>
                                    <div className="flex-1">
                                        <ReactSelect
                                            options={departmentOptions}
                                            value={departmentOptions.find((opt) => opt.value === formData.department)}
                                            onChange={(selectedOption) => setFormData({ ...formData, department: selectedOption.value })}
                                            placeholder="Select Department"
                                            styles={{
                                                container: (base) => ({
                                                    ...base,
                                                    width: '100%',
                                                }),
                                                control: (base) => ({
                                                    ...base,
                                                    width: '100%', 
                                                    textOverflow: 'ellipsis', 
                                                    overflow: 'hidden',
                                                    textAlign:'justify'
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-3">
                                        <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-900 mb-2 text-justify">
                                            Image
                                        </label>

                                    </div>
                                    <div className="col-span-9">
                                        {
                                            formData.image == '' ? <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                                                <PhotoIcon aria-hidden="true" className="text-gray-300 h-12 w-12 mb-2" />
                                                <div className="flex items-center text-sm text-gray-600">
                                                    <label
                                                        htmlFor="file-upload"
                                                        className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                                    >
                                                        <span>Upload a file</span>
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"

                                                            accept="image/jpeg,image/png,image/jpg"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                    <p className="pl-2">or drag and drop</p>
                                                </div>
                                                <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                                            </div> :
                                                <>
                                                    <img
                                                        src={`${process.env.REACT_APP_IMAGE_URL}/${formData.image}`}
                                                        alt="Cover"
                                                        className="w-full h-40 object-cover rounded-lg mb-3"
                                                        loading="lazy"
                                                    />

                                                    <label
                                                        htmlFor="file-upload"
                                                        className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                                    >
                                                        <span>Change Image</span>
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                </>
                                        }
                                    </div>
                                </div>

                                <div className="flex  gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Social Links</label>
                                    <div className="grid grid-cols-2 gap-4">
                                        {[
                                            { field: "website", label: "Website URL" },
                                            { field: "facebook", label: "Facebook URL" },
                                            { field: "instagram", label: "Instagram URL" },
                                            { field: "twitter", label: "Twitter URL" },
                                            { field: "youtube", label: "Yotube URL" },
                                            { field: "linkedin", label: "LinkdedIn URL" },
                                        ].map(({ field, label }) => (
                                            <input
                                                key={field}
                                                type="text"
                                                placeholder={label}
                                                value={formData[field] || ""}
                                                onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                                                className="w-full rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                    >
                                        {allmodel?.data?._id ? "Update" : "Add"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddDoctors;
